require('./override.sass');

module.exports = {
  placeOrderTermsOfService: 'https://www.example.org',
  api: {
    url: 'https://cloud.zeyos.com/hoess/remotecall/zeyos.portal.api/'
  },
  theme: 'dark',
  documentTitle: 'Maschinenbau Höss',
  title: `<span class="logo-red">B2B</span><span class="font-weight-light">Portal</span>`,
  logo: require('./assets/logo.png'),
  i18n: {
    messages: {
      en: {
        Deliveries: {
          num: 'Delivery no.',
          shippingRef: 'Shipping Ref.',
          trackingNum: 'Tracking No.',
        },
        Notes: {
          title: 'Documents',
          news: 'News',
        },
        Dashboard: {
          title: 'Dashboard',
          News: 'News',
          Support: 'Support',
        },
      },
      de: {
        Deliveries: {
          num: 'Lieferung Nr.',
          shippingRef: 'Sendungsref.',
          trackingNum: 'Tracking-Nr.',
        },
        Notes: {
          title: 'Documente',
          news: 'Nachrichten',
        },
        Dashboard: {
          title: 'Dashboard',
          News: 'News',
          Support: 'Ihre Ansprechpartner',
        },
      }
    }
  },
  topMenu: [],
  cart: true,
  menu: [{
    name: 'orders',
    icon: 'history',
    title: 'Application.orders',
    component: () => import('./core/src/modules/Transactions'),
    props: {
      type: 'orders',
      columns: [{
        field: "transactionnum",
        label: "Orders.orderNum",
      }, {
        field: ["orderstatus", "status"],
        label: "Common.status",
      }, {
        field: "date",
        label: "Common.date",
        type: "date",
      }, {
        field: "netamount",
        label: "Common.netAmount",
        type: "num",
        align: "right",
      }, {
        field: "tax",
        label: "Common.taxAmount",
        type: "num",
        align: "right",
      }, {
        field: "total",
        label: "Common.total",
        type: "num",
        sortable: false,
        align: "right",
      }]
    }
  }, {
    name: 'deliveries',
    icon: 'departure_board',
    title: 'Application.deliveries',
    component: () => import('./core/src/modules/Transactions'),
    props: {
      type: 'deliveries',
      columns: [{
        field: "transactionnum",
        label: "Deliveries.num",
      }, {
        field: "shippingref",
        label: "Deliveries.shippingRef",
      }, {
        field: "trackingnum",
        label: "Deliveries.trackingNum",
      }, {
        field: "date",
        label: "Common.date",
        type: "date",
      }, {
        field: "netamount",
        label: "Common.netAmount",
        type: "num",
        align: "right",
      }, {
        field: "tax",
        label: "Common.taxAmount",
        type: "num",
        align: "right",
      }, {
        field: "total",
        label: "Common.total",
        type: "num",
        sortable: false,
        align: "right",
      }]
    }
  }, {
    name: 'billing',
    icon: 'attach_money',
    title: 'Application.invoices',
    pinProtected: true,
    component: () => import('./core/src/modules/Transactions'),
    props: {
      type: 'billing',
      columns: [{
        field: "transactionnum",
        label: "Invoices.invoiceNum",
      }, {
        field: "date",
        label: "Common.date",
        type: "date",
      }, {
        field: "status",
        label: "Common.status",
        type: "num",
      }, {
        field: "netamount",
        label: "Common.netAmount",
        type: "num",
        align: "right",
      }, {
        field: "tax",
        label: "Common.taxAmount",
        type: "num",
        align: "right",
      }, {
        field: "total",
        label: "Common.total",
        type: "num",
        sortable: false,
        align: "right",
      }]
    }
  }]
}
